export default __webpack_public_path__ + "static/media/goUp.2b32b953.svg";